import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/account-email`;

export const accountEmailService = {
    createAccountEmail: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-account-email`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateAccountEmail: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-account-email`, params)
            .then((response) => {
                return response.data;
            });
    },
    deleteAccountEmail: async function (params: any) {
        console.log(params)
        return axios.delete(`${GATEWAY_URL}/delete-account-email`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    getAccountEmails: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-account-emails`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
}